/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import Icon from 'components/icon';
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form } from 'react-bootstrap';
import { currencyFormat } from 'helpers/utils';
import { useAlert } from 'providers/AlertModalProvider';
import postData from 'services/postData';
import PinInput from 'react-pin-input';
import { useEffect, useRef } from 'react';
import PageLoader from 'components/custom/animate-component/PageLoader';
import apiEndpoints from 'constants/apiEndpoints';

const CustomModal = styled(Modal)`
  background-color: #0000004b;
  backdrop-filter: blur(2px);
  & .modal-dialog {
    margin-right: auto;
    margin-left: auto;
  }
  & .modal-header .btn-close {
    background-color: #ffffff39;
  }
`;

function AmountChangeModal({
  show,
  handleClose,
  challan,
  trans_for,
  refreshData
}) {
  const [loading, setLoading] = useState(false);
  const [pinRef, setPinRef] = useState(false);
  const [pin, setPin] = useState('');
  const [isPinCorrect, setIsPinCorrect] = useState(true);
  const { showAlert } = useAlert();
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleOnSubmit = async values => {
    setLoading(true);
    const requestStatus = await postData(
      {
        challan_id: challan.challan_id,
        trans_for: trans_for,
        transaction_pin: pin,
        amount: values.amount
      },
      apiEndpoints.challan.payViaCash
    );
    if (requestStatus.status) {
      setLoading(false);
      handleClose();
      refreshData();
      showAlert({
        variant: 'success',
        message: `Payment of ${currencyFormat(values.amount)} to the driver ${
          challan.drivername
        } via cash was successful.`
      });
    } else {
      if (requestStatus.message === 'Invalid transaction PIN') {
        setIsPinCorrect(false);
        pinRef?.clear();
        setPin('');
        setLoading(false);
      } else {
        setLoading(false);
        showAlert({
          variant: 'danger',
          message: `Failed to pay cash: ${requestStatus.message}`
        });
      }
    }
  };

  const { handleChange, handleBlur, values, errors, touched, handleSubmit } =
    useFormik({
      initialValues: {
        amount: Number(challan.driver_advance) || 0
      },
      validationSchema: Yup.object({
        amount: Yup.number('Must be a number')
          // .positive('Must be greater than 0')
          .required('Please provide amount')
          // .max(3000, `Amount must not exceed ${currencyFormat('3000')}`)
          // .min(
          //   challan.driver_advance,
          //   `Amount must not be lower than ${currencyFormat(
          //     challan.driver_advance || 0
          //   )}`
          // )
          .max(
            Math.min(3000, challan.driver_advance),
            `Amount must not exceed ${currencyFormat(Math.min(3000, challan.driver_advance || 0))}`
          )
          .min(0, 'Amount must be at least 0')
      }),

      onSubmit: values => {
        handleOnSubmit(values);
      }
    });

  const handleChangePin = val => {
    setPin(val);
    if (!isPinCorrect) {
      setIsPinCorrect(true);
    }
  };

  return (
    <CustomModal show={show} onHide={() => {}} backdrop="static" centered>
      <Modal.Header className="border-0 d-flex justify-content-center">
        <Modal.Title>
          <Icon
            icon={'streamline:warning-triangle-solid'}
            className={`text-${'warning'}`}
            fontSize="48px"
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2">
          <p className="mb-2 text-1000 ">
            Do you want to proceed with paying the driver{' '}
            <span className=" fw-bold ">{challan.driver_name}</span> in cash?
          </p>
        </div>
        <div className="d-flex align-items-center flex-column ">
          <div className="mb-1">
            <Form.Group controlId="amount">
              <div className="d-flex justify-content-center">
                <div>
                  <Form.Label className="ps-1">Amount to pay</Form.Label>
                  <Form.Control
                    type="number"
                    ref={inputRef}
                    isInvalid={touched.amount && errors.amount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.amount}
                    // className="border border-warning text-warning"
                    style={{ width: '180px' }}
                    size="sm"
                    // disabled
                  />
                </div>
              </div>
              <Form.Control.Feedback className="d-inline fs-10" type="invalid">
                {errors.amount}
              </Form.Control.Feedback>
              {!errors.amount &&
              values.amount !== Number(challan.driver_advance || 0) ? (
                <p className="fs-10 ms-1 mt-1 mb-0 text-warning">
                  Actual amount is {currencyFormat(challan.driver_advance || 0)}
                </p>
              ) : null}
            </Form.Group>
          </div>
          <div>
            <Form.Label className="ps-1">Insert Payment Pin</Form.Label>
            <PinInput
              inputFocusStyle={{
                outline: 0,
                borderWidth: '2px',
                padding: ' 0.05rem',
                borderColor: '#004DFF'
              }}
              inputStyle={{
                borderWidth: '1px',
                lineHeight: '1.5',
                borderRadius: '8px',
                fontSize: '1rem',
                borderStyle: 'solid',
                letterSpacing: '0.15px',
                padding: '0.05rem',
                backgroundColor: 'transparent',
                //   color: '#fff',
                fontFamily:
                  'Inter, sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                borderColor: '#757575',
                WebkitTransition:
                  'border-color 300ms cubic-bezier(0.4, 0q 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                transition:
                  'border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                maxWidth: '40px',
                textAlign: 'center',
                height: '40px'
                // marginTop: '0.5rem',
                // marginBottom: '0.5rem'
              }}
              length={4}
              focus
              // disabled
              // secret
              className="text-white mx-auto"
              ref={p => setPinRef(p)}
              type="numeric"
              onChange={handleChangePin}
            />
            {!isPinCorrect ? (
              <small className="text-danger">Incorrect Pin</small>
            ) : null}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 d-flex justify-content-center">
        <Button
          disabled={loading}
          variant="outline-secondary"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          variant={'warning'}
          disabled={errors.amount || loading || pin?.length !== 4}
          onClick={handleSubmit}
        >
          Pay
        </Button>
      </Modal.Footer>
      <PageLoader loading={loading} loadingMessage={'Pay via cash'} />
    </CustomModal>
  );
}

export default AmountChangeModal;
